import { Text, View } from "react-native";

import { useLiveRegionStore } from "@/store/liveRegion";

const hiddenStyle = {
  position: "absolute" as const,
  width: 1,
  height: 1,
  overflow: "hidden" as const,
  opacity: 0,
};

export default function LiveRegion() {
  const politeMessage = useLiveRegionStore((s) => s.politeMessage);
  const assertiveMessage = useLiveRegionStore((s) => s.assertiveMessage);

  return (
    <>
      <View role="status" aria-live="polite" style={hiddenStyle}>
        <Text>{politeMessage}</Text>
      </View>
      <View role="alert" aria-live="assertive" style={hiddenStyle}>
        <Text>{assertiveMessage}</Text>
      </View>
    </>
  );
}
